shadow$provide[141] = function(require,module,exports) {
module.exports=({"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}
);
};